module.exports = __webpack_public_path__ + "media/applicants/check-circle_2x-614c7b4c.png";